module.exports = __webpack_public_path__ + "static/media/logsIcon.fc33f021.svg";